<template>
    <svg
        :width="width"
        :height="height"
        viewBox="0 0 13 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        :class="color"
    >
        <path
            d="M2.66667 6.66667C2.31304 6.66667 1.97391 6.52619 1.72386 6.27614C1.47381 6.02609 1.33333 5.68695 1.33333 5.33333V0H0V5.33333C0 6.04058 0.280952 6.71885 0.781049 7.21895C1.28115 7.71905 1.95942 8 2.66667 8H9.53733L7.014 10.5233L7.95733 11.466L12.2 7.22333L7.95733 2.98067L7.014 3.924L9.75733 6.66733L2.66667 6.66667Z"
            fill="currentColor"
        />
    </svg>
</template>

<script>
export default {
    name: 'corner-down-right-icon',
    props: {
        width: {
            type: [String, Number],
            default: 13,
        },
        height: {
            type: [String, Number],
            default: 12,
        },
        color: {
            type: String,
            default: 'text-content-basic-2',
        },
    },
};
</script>
